<template>
  <div>
    <div v-if="category == 2">{{ temp.name }}</div>
    <el-select v-model="selected" multiple class="long" @change="handleChange">
      <el-option
        v-for="param in temp.custom_params"
        :label="param.label"
        :value="param.label"
        :key="param.label"
      ></el-option>
    </el-select>
  </div>
</template>


<script>
import { itemTemplateDetail, productTemplateDetail } from '@/service/getData'

export default {
  props: {
    id: Number,
    category: Number,
    val: Array,
  },
  data() {
    return {
      temp: {},
      selected: [],
    }
  },
  created() {
    if (this.val && this.val.length > 0) {
      this.selected = this.val
    }
    this.getData()
  },

  methods: {
    async getData() {
      if (!this.id) return
      let res
      // 1:成品 2:配件
      if (this.category === 1) {
        res = await productTemplateDetail(this.id)
      } else {
        res = await itemTemplateDetail(this.id)
      }
      this.temp = res.data
    },

    handleChange(e) {
      this.$emit('change', e)
    },
  },
}
</script>